import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 運営からのお知らせ一覧
 *
 * 運営からのお知らせデータの一覧を返す
 */
export class FetchNotice implements APIRequest<Monitaro.FetchNoticeResponse> {
  response: Monitaro.FetchNoticeResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/notices`
  }
}

/**
 * 運営からのお知らせデータの取得
 *
 * 指定されたIDの運営からのお知らせ情報を返す
 */
export class GetNotice implements APIRequest<Monitaro.GetNoticeResponse> {
  response: Monitaro.GetNoticeResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(notice: string) {
    this.path = `/notices/${notice}`
  }
}
